import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

import { createPayload } from "@/utils";

export const useRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getValues } = useFormContext();

  const goNextRoute = (to: string) => {
    const now = Date.now();
    navigate(location.pathname, {
      state: { ...createPayload(getValues(), now) },
      replace: true,
    });
    navigate(to, {
      state: { ...createPayload(getValues(), now) },
    });
  };

  const goBackRoute = (to: string) => {
    navigate(to, {
      state: { ...createPayload(getValues()) },
    });
  };

  return {
    goBackRoute,
    goNextRoute,
  };
};
